<h2 mat-dialog-title>Non è possibile avviare l'onboarding</h2>

<h3 class="strong" *ngIf="data.isSeller; else buyer">
  Completa i seguenti campi obbligatori:
</h3>

<ng-template #buyer>
  <h3 class="strong">
    Rivolgersi a CashMe per aggiornare i seguenti campi obbligatori:
  </h3>
</ng-template>




<mat-dialog-content>
    <div *ngIf="data.errors?.length" class="error-list">
        <ul>
            <li *ngFor="let error of data.errors">{{ error }}</li>
        </ul>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="undefined">
        <span>Chiudi</span>
    </button>
</mat-dialog-actions>